import { IoIosEye, IoIosEyeOff } from "react-icons/io"
import TextInput from "./text-input"
import { Colors } from "../../config"
import { useState } from "react"

export default function PasswordInput({ ...rest }) {
    const [show, setShow] = useState(false)

    return <div className="relative">
        <TextInput
            {...rest}
            type={show ? "text" : "password"}
        />
        <p className='cursor-pointer absolute right-4 top-1/2 -translate-y-1/2' onClick={() => setShow(prev => !prev)}>
            {
                show ? <IoIosEye size={18} color={Colors.LabelColor} /> : <IoIosEyeOff size={18} color={Colors.LabelColor} />
            }   
        </p>
    </div>
}